<bootstrap-popup
	[id]="id"
	[title]="title"
	[windowCloseButton]="true"
	[displaySubject]="displaySubject"
	>
	<div *ngIf="loaded">
	<form role="form" class="form-horizontal" *ngIf="!(creationImpossible$ | async)">
		<div class="panel panel-default panel-horizontal-form-fix">
			<div class="panel-heading"><h3>Le p&eacute;rim&egrave;tre</h3></div>
			<div class="row" style="margin-top: 10px">
				<div class="col-sm-6">
					<div class="form-group choixPerimetreAcces" style="margin-top: 0px" *ngIf="user.role === 'CCE'">
						<cc-antenne-selector
							[id]="'eantenne'"
							[disabled]="mode === 'update'"
							[mandatory]="true"
							[labelClass]="'col-sm-2'"
							[fieldClass]="'col-sm-10'"
							[wildcardOptionLabel]="null"
							[resetCommands]="antenneResetCommands"
							(selectedAntenneChange)="antenne$.next($event)"
							>
						</cc-antenne-selector>
					</div>
					<div class="form-group">
						<parc-filterable-selector-for-cc
							[id]="'choixparc'"
							[disabled]="mode === 'update'"
							[mandatory]="true"
							[labelClass]="'col-sm-2'"
							[fieldClass]="'col-sm-10'"
							[selectedParcId]="(parc$ | async)?.id"
							[antenneId]="(antenne$ | async)?.id"
							(selectedParcChange)="parc$.next($event)"
							>
						</parc-filterable-selector-for-cc>
 					</div>
					<div *ngIf="(parc$ | async) as parc" class="form-group" style="margin-bottom: 0px">
						<div class="col-sm-2">&nbsp;</div>
						<div class="col-sm-10 description-parc"> 
							<p *ngIf="parc.type || parc.energie">
								<span *ngIf="parc.type">Type: {{ parc?.type }}</span>
								<span *ngIf="parc.type && parc.energie"> - </span>
								<span *ngIf="parc.energie">Technologie: {{ parc.energie }}</span>
							</p>
							<p *ngIf="responsableParc as responsable">
								<span>R&eacute;f. de parc: {{ responsable.prenom }} {{ responsable.nom }}</span>
								<span *ngIf="responsableParc?.telephone">
									&nbsp;&nbsp;
									<i class="fa fa-phone-square"></i>
									{{ responsable.indicatifTelephone }} {{ responsable.telephone }}
								</span>
								<span *ngIf="responsableParc?.email">
									&nbsp;&nbsp;
									<i class="fa fa-envelope"></i>
									{{ responsable.email }}
								</span>
							</p>
						</div>
					</div>
					<div *ngIf="(antenne$ | async) as antenne" class="form-group" style="margin-bottom: 0px">
						<div class="col-sm-2" *ngIf="antenne.telephoneAstreintes && antenne.telephoneAstreintes.length">&nbsp;</div>
						<div class="col-sm-10 description-antenne" *ngIf="antenne.telephoneAstreintes && antenne.telephoneAstreintes.length"> 
							<p>
								<span>Tel astreinte: {{ antenne.telephoneAstreintes.join(', ') }}</span>
							</p>
						</div>
					</div>
				</div>
				<div class="col-sm-6" style="margin-top: 10px"></div>
			</div> 
			<div class="row" style="margin-top: 10px" *ngIf="(parc$ | async) as parc">
				<div class="col-sm-12">
					<div class="form-group">
						<label for="choixOuvrages" class="col-sm-1 control-label">Ouvrage&nbsp;*:</label>
						<div class="col-sm-11 groupChoixOuvrages">
							<ouvrage-by-sous-parc-multi-selector-with-notes
								[id]="'choixOuvrages'"
								[maxNumberOfSelections]="maxOuvrageSelectables$ | async"
								[disabled]="mode === 'update' || !!(modeSolaireLocal$ | async)"
								[fieldClass]="'col-sm-6 selector'"
								[notesClass]="'col-sm-5'"
								[dateRef]="dateTimeDebutJS$ | async"
								[reinitCommands]="reinitOuvragesFieldCommands$"
								(selectedOuvragesChange)="ouvrages$.next($event)"
								>
							</ouvrage-by-sous-parc-multi-selector-with-notes>
						</div>
					</div>
				</div>
				<div class="col-sm-12">
					<div class="form-group" style="margin-bottom: 0px" *ngIf="allowsOuvragesConcernes$ | async">
						<label for="choixOuvragesConcernes" class="col-sm-1 control-label" style="padding-top: 0px">Ouvrage(s)<br/>concern&eacute;(s)&nbsp;:</label>
						<div class="col-sm-11 groupChoixOuvrages">
							<ouvrage-by-sous-parc-multi-selector-with-notes
								[id]="'choixOuvragesConcernes'"
								[disabled]="acces != null && acces.etat > 1 && mode !== 'duplicate'"
								[fieldClass]="'col-sm-6 selector'"
								[notesClass]="'col-sm-5'"
								[dateRef]="dateTimeDebutJS$ | async"
								[reinitCommands]="reinitOuvragesConcernesFieldCommands$"
								(selectedOuvragesChange)="ouvragesConcernes$.next($event)"
							>
							</ouvrage-by-sous-parc-multi-selector-with-notes>
						</div>
					</div>
				</div>
				<div class="col-sm-12" *ngIf="(parc$ | async) as parc">
					<div class="form-group" *ngIf="parc.vigilanceIncendie === '1' && (niveauAlertIncendie$ | async) as niveau">
						<label class="col-sm-1 control-label" style="padding-top: 0px">M&eacute;t&eacute;o&nbsp;:</label>
						<div class="col-sm-11 popover__wrapper" style="margin-top: 0px">
							<a href="#">
								<i class="fa fa-2x fa-brands fa-gripfire" [style.color]="niveau.codeCouleurAurora"></i>
							</a>
							<div class="popover__content">
								<div class="panel panel-default modal-sm">
									<div class="panel-heading" role="document">
										<h3>D&eacute;tails</h3>
									</div>
									<div class="panel-body">
										<strong>Niveau incendie:</strong><br/>
										<span>{{ parc.niveauIncendie ? niveau.couleurCassini : 'inconnu' }}</span><br/>
										<br/>
										<ng-container *ngIf="parc.regleIncendie">
											<strong>R&egrave;gle applicable incendie:</strong><br/>
											<span>{{ parc.regleIncendie }}</span>
										</ng-container>
										<strong *ngIf="!parc.regleIncendie">Aucune r&egrave;gle incendie connue.</strong>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
						
		<div class="panel panel-default">
			<div class="panel-heading"><h3>L'acc&egrave;s</h3></div>
			<div class="panel-body">
				<div class="form-group">
					<label for="numeroTransfert" class="col-sm-3 control-label">Num&eacute;ro de transfert&nbsp;:</label>
					<div class="col-sm-4">
						<input type="text"
							id="numeroTransfert"
							name="numeroTransfert"
							class="form-control"
							readonly="readonly"
							[ngModel]="numero$ | async"
						/>
					</div>
				</div>
				<div class="form-group">
					<label for="heureDebut" class="col-sm-3 col-xs-3 control-label">Heure de d&eacute;but&nbsp;*:</label>
					<div class="col-sm-1 col-xs-9">
						<time-input
							[id]="'heureDebut'"
							[disabled]="(mode === 'update' && acces != null && acces.etat > 1)"
							[stepMinute]="1"
							[localTime]="heureDebut$ | async"
							(localTimeChange)="heureDebut$.next($event)"
							>
						</time-input>
					</div>
					<label for="dateDebut" class="col-sm-1 col-xs-3 control-label">le&nbsp;*:</label>
					<div class="col-sm-2 col-xs-9">
						<date-input 
							[id]="'dateDebut'"
							[disabled]="acces != null && acces.etat > 1"
							[localDate]="dateDebut$ | async"
							(localDateChange)="dateDebut$.next($event)"
						>
						</date-input>
					</div>
					<button
						*ngIf="acces != null && acces.etat <= 1"
						type="button"
						class="btn btn-primary btn-xs"
						style="margin-top: 5px"
						(click)="resetDateCommands.next()"
						>
						Date et heure actuelle
					</button>
				</div>
				<div class="form-group">
					<label for="commentaire" class="col-sm-3 control-label">Commentaire&nbsp;:</label>
					<div class="col-sm-9">
						<textarea type="text"
							id="commentaire" name="commentaire"
							class="form-control"
							maxlength="255"
							[(ngModel)]="commentaire"
							>
						</textarea>
					</div>
				</div>
				<div class="form-group" *ngIf="mode == 'creation'">
					<label for="lierIntervention" class="col-sm-3 control-label">Lier &agrave; une op&eacute;ration&nbsp;*?</label>
					<div class="col-sm-9">
						<label class="radio-inline" *ngFor="let option of ouiNonOptions; let indexOption = index">
							<input type="radio"
								[name]="'lierIntervention'"
								[id]="'lierIntervention_' + indexOption"
								[value]="option.value"
								disabled
								required
								[(ngModel)]="lierIntervention"
							/>
							{{ option.label }}
						</label>
					 </div>
				</div>
				<div class="form-group">
					<label for="accesCegex" class="col-sm-3 control-label">Acc&egrave;s CEGEX&nbsp;*?</label>
					<div class="col-sm-9">
						<label class="radio-inline" *ngFor="let option of ouiNonOptions; let indexOption = index">
							<input type="radio" disabled
								[name]="'accesCegex'"
								[id]="'accesCegex_' + indexOption"
								[value]="option.value"
								[ngModel]="accesCegex$ | async"
								(ngModelChange)="accesCegex$.next($event)"
							/>
							{{ option.label }}
						</label>
					</div>
				</div>
				<div class="form-group">
					<label for="astreinte" class="col-sm-3 control-label">Astreinte&nbsp;?</label>
					<div class="col-sm-9">
						<label class="radio-inline" *ngFor="let option of ouiNonOptions; let indexOption = index">
							<input type="radio" disabled required
								[name]="'astreinte'"
								[id]="'astreinte_' + indexOption"
								[value]="option.value"
								disabled
								required
								[ngModel]="astreinte$ | async"
							/>
							{{ option.label }}
						</label>
					 </div>
				</div>
			</div>
		</div>
		<div class="form-group">
			<div class="col-sm-12 text-center actions">
				<button 
					type="button"
					class="btn btn-default"
					(click)="close()"
					>
					Annuler
				</button>&nbsp;
				<ng-container *ngIf="mode === 'creation'">
					<button
						type="button"
						class="btn btn-primary"
						[disabled]="waitingForServer"
						(click)="createNewPlannedAcces(false)"
						>
						Planifier
					</button>
					<button type="button"
						*ngIf="!(userCanGrantAcces$ | async) && atLeastOneOuvrageSelected()"
						class="btn btn-success"
						[disabled]="waitingForServer"
						(click)="createNewPlannedAcces(true)"
						>
						Demander une validation
					</button>
					<button
						*ngIf="(userCanGrantAcces$ | async)"
						type="button"
						class="btn btn-success"
						[disabled]="waitingForServer"
						(click)="createNewGrantedAcces()"
						>
						Autoriser
					</button>
				</ng-container>
				<ng-container *ngIf="mode !== 'duplicate' && (!acces || acces.etat <= 1) && (userCanGrantAcces$ | async)">
					<select
						name="controleSecurite" id="controleSecurite"
						class="form-control"
						style="width: 18em; display: inline; padding-top: 3px;"
						[(ngModel)]="controleSecurite"
						>
						<option [ngValue]="null">&nbsp;</option>
						<option *ngFor="let option of (controlesSecurite$ | async)" [ngValue]="option.id">{{ option.label }}</option>
					</select>
					<button type="button"
						class="btn btn-danger"
						[disabled]="waitingForServer"
						(click)="createNewDeniedAcces()" >
						Refuser
					</button>
					<select
						name="motifRefus" id="motifRefus"
						class="form-control"
						style="width: 18em; display: inline; padding-top: 3px;"
						[(ngModel)]="motifRefus"
						>
						<option [ngValue]="null">&nbsp;</option>
						<option *ngFor="let option of (motifsRefus$ | async)" [ngValue]="option.id">{{ option.libelle }}</option>
					</select>
				</ng-container>
			</div>
		</div>
	</form>
	<h1 class="unknown-intervenant" *ngIf="(creationImpossible$ | async)">Vous n'êtes pas enregistré comme intervenant AURORA</h1>
	</div>
</bootstrap-popup>

<coactivite-solaire-checker
	[id]="'coactiviteSolCcCheckerDialogOfModal'"
	[checkCommands]="checkCoactiviteSolaireCommands"
	>
</coactivite-solaire-checker>

<coactivite-eolien-checker
	[id]="'coactiviteEolCcCheckerDialogOfModal'"
	[checkCommands]="checkCoactiviteEolienCommands"
	>
</coactivite-eolien-checker>